import { Injectable } from '@angular/core';
import {BehaviorSubject, Subject} from "rxjs";
import {Attachment, Model, NotSelectedModel} from "./api.service";
import {FileExtended} from "../main/components/body/components/chat-main/chat-main-prompt/chat-main-prompt.component";

@Injectable({
  providedIn: 'root'
})
export class AppStateService {

  constructor(
  ) { }

//  public defaultAIModel = new BehaviorSubject<Model>(new NotSelectedModel());
  public selectedAIModel = new BehaviorSubject<Model>(new NotSelectedModel()); //this.api.getDefaultChatModel()

  public lastUsedModel = new BehaviorSubject<Model | undefined>(undefined);

  public updateSidebarConversationItem = new BehaviorSubject<UpdateSidebarConversationItemProps>({
    model: new NotSelectedModel(),
    conversationId: ''
  }); //this.api.getDefaultChatModel()

  public selectedDropdownModel = new BehaviorSubject<Model>(new NotSelectedModel()); //this.api.getDefaultChatModel()

  public conversationAttachments = new BehaviorSubject<Attachment[]>([]);

  public setConversationAttachments(attachment: Attachment): void {
    const currentValue = this.conversationAttachments.value;
    this.conversationAttachments.next([...currentValue, attachment]);
  }

  public deleteAttachment(attachment: FileExtended) {
    const currentValue = this.conversationAttachments.value;
    const updatedAttachmentList = currentValue.filter(file => file.fileId !== attachment.id);
    this.conversationAttachments.next(updatedAttachmentList);
  }

  public clearConversationAttachments(): void {
    this.conversationAttachments.next([]);
  }


}

interface UpdateSidebarConversationItemProps {
  model: Model;
  conversationId: string;
}